// extracted by mini-css-extract-plugin
export default {"searchResultsLayout":"SearchResultsLayout_searchResultsLayout__Zh8bS","header":"SearchResultsLayout_header__0peto","content":"SearchResultsLayout_content__epTJl"};